import axios from "axios";

const api = axios.create({
  baseURL: "https://dash-fune.herokuapp.com/",

});

export default api;
